import { OrderModel } from 'src/app/store/order/model';

export abstract class AbstractOrderUIService {
  public abstract isDisabled(order: OrderModel): boolean;
  public abstract validateFiles(files: any[]): boolean;
}
